import React from 'react';
import Editor from './Editor';


class App extends React.Component {


  render(){
          return(
            <div>
              <Editor />
            </div>
          );
      };

}

export default App;
